"use strict";
exports.__esModule = true;
exports.IntegrationProviders = void 0;
var IntegrationProviders;
(function (IntegrationProviders) {
    IntegrationProviders["CHANNEX"] = "CHANNEX";
    IntegrationProviders["ADSHOTEL"] = "ADSHOTEL";
    IntegrationProviders["TOURVISIO"] = "TOURVISIO";
    IntegrationProviders["SEJOUR"] = "SEJOUR";
})(IntegrationProviders = exports.IntegrationProviders || (exports.IntegrationProviders = {}));
;
//# sourceMappingURL=integration.interfaces.js.map